/** Classes partagées — alignées sur tms-frontend/src/pages/optimization */
export const opt = {
  page: 'min-h-screen bg-gray-50 dark:bg-gray-950',
  pageHeader: 'bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700',
  headerInnerLg: 'w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 py-8',
  headerInnerMd: 'w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 py-6',
  headerInnerSm: 'w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 py-4',
  content: 'w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 py-8',
  h1: 'text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white',
  h1Truncate: 'text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white truncate',
  subtitle: 'mt-2 text-xs sm:text-base text-gray-600 dark:text-gray-400',
  subtitleSm: 'text-xs sm:text-sm text-gray-400 dark:text-gray-400 mt-1',
  backBtn: 'flex items-center gap-2 text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 mb-4',
  card: 'bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700',
  cardP6: 'bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6',
  cardPanel: 'bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 p-6',
  kpiCard: 'bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-2 sm:p-4',
  fieldset: 'bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6',
  input:
    'w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:ring-blue-500 focus:border-blue-500',
  label: 'block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1',
  labelMb2: 'block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2',
  legend: 'text-lg sm:text-xl font-semibold text-gray-900 dark:text-white mb-4',
  legendXl: 'text-xl font-semibold text-gray-900 dark:text-white mb-4',
  textMuted: 'text-gray-600 dark:text-gray-400',
  textHelp: 'text-xs text-gray-500 dark:text-gray-500 mt-1',
  emptyState: 'text-center py-12 bg-white dark:bg-gray-800 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600',
  listItem:
    'bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-blue-400 dark:hover:border-blue-500 cursor-pointer transition-all p-3 sm:p-6 min-h-32 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-950',
  sortBtnActive: 'bg-blue-600 text-white',
  sortBtnInactive:
    'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600',
  tabBar: 'mb-6 border-b border-gray-200 dark:border-gray-700 overflow-x-auto',
  tabActive: 'border-blue-600 text-blue-600 dark:border-blue-500 dark:text-blue-400',
  tabInactive: 'border-transparent text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-300',
  alertRunning:
    'mb-6 bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-700 rounded-lg p-4 flex items-center',
  alertRunningTitle: 'font-semibold text-blue-900 dark:text-blue-300',
  alertRunningText: 'text-sm text-blue-700 dark:text-blue-400',
  alertError: 'mb-6 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-700 rounded-lg p-4',
  alertErrorTitle: 'font-semibold text-red-900 dark:text-red-300 mb-2',
  alertErrorText: 'text-sm text-red-700 dark:text-red-400',
  alertErrorBox: 'bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-700 rounded-lg p-6 text-red-700 dark:text-red-300',
  alertWarnBox: 'bg-yellow-50 dark:bg-yellow-900/30 border border-yellow-200 dark:border-yellow-700 rounded-lg p-6 text-yellow-800 dark:text-yellow-300',
  spinner: 'inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 dark:border-blue-500',
  spinnerSm: 'animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600 dark:border-blue-500',
  loadingCenter: 'min-h-screen bg-gray-50 dark:bg-gray-950 flex items-center justify-center',
  loadingText: 'text-gray-600 dark:text-gray-400',
  itemRow: 'flex items-center justify-between bg-gray-50 dark:bg-gray-900 p-3 rounded',
  sidebarSticky: 'bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6 sticky top-8',
  divider: 'border-b border-gray-200 dark:border-gray-700',
  h3: 'text-base sm:text-lg font-semibold text-gray-900 dark:text-white mb-4',
  h3Lg: 'text-lg font-semibold text-gray-900 dark:text-white mb-4',
  dt: 'text-gray-600 dark:text-gray-400',
  dd: 'font-semibold text-gray-900 dark:text-white',
  emptyPanel: 'text-center py-12 text-gray-600 dark:text-gray-400',
} as const

export function statusBadgeClass(status: string): string {
  const base = 'inline-block px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-semibold whitespace-nowrap'
  switch (status) {
    case 'completed':
      return `${base} bg-green-100 text-green-800 border border-green-200 dark:bg-green-900/50 dark:text-green-300 dark:border-green-700`
    case 'running':
      return `${base} bg-blue-100 text-blue-800 border border-blue-200 dark:bg-blue-900/50 dark:text-blue-300 dark:border-blue-700`
    case 'failed':
      return `${base} bg-red-100 text-red-800 border border-red-200 dark:bg-red-900/50 dark:text-red-300 dark:border-red-700`
    case 'queued':
      return `${base} bg-yellow-100 text-yellow-800 border border-yellow-200 dark:bg-yellow-900/50 dark:text-yellow-300 dark:border-yellow-700`
    case 'cancelled':
      return `${base} bg-gray-100 text-gray-800 border border-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600`
    default:
      return `${base} bg-gray-100 text-gray-800 border border-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600`
  }
}

export function listStatusBadgeClass(status: string): string {
  switch (status) {
    case 'completed':
      return 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300'
    case 'running':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-300'
    case 'failed':
      return 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300'
    case 'cancelled':
      return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
    case 'queued':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-300'
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
  }
}
